<script>
/**
 * @overview 首页入口
 *
 * @author huojinzhao
 */

import HomeHeader from "./components/HomeHeader.vue";

export default {
  name: "ViewHome",

  components: {
    HomeHeader,
  },

  data: () => ({
    menus: [
      {
        label: "场景管理",
        path: "/theme",
      },
      {
        label: "素材管理",
        path: "/material",
      },
      {
        label: "游戏管理",
        path: "/game",
      },
      {
        label: "课时管理",
        path: "/course",
      },
    ],
    menusTwo: [
      {
        label: "课件列表",
        path: "/courseList",
      },
    ],
  }),

  methods: {
    enterRoute(path) {
      this.$router.push(path);
    },
  },
};
</script>

<template>
  <div class="layout-screen view-home">
    <HomeHeader />

    <main class="view-home__body">
      <router-link
        :to="'/setting'"
        class="configBtn">
        <i class="el-icon-setting"/>
        配置项
      </router-link>
      <div class="row-one">
        <el-card
          v-for="menu in menus"
          :key="menu.label"
          shadow="hover"
          @click.native="() => enterRoute(menu.path)"
        >
          {{ menu.label }}
        </el-card>
      </div>
      <div class="row-two">
        <el-card
          v-for="menu in menusTwo"
          :key="menu.label"
          shadow="hover"
          @click.native="() => enterRoute(menu.path)"
        >
          {{ menu.label }}
        </el-card>
      </div>
    </main>
  </div>
</template>

<style lang="postcss">
.view-home {
  display: flex;
  flex-direction: column;
}

.view-home__body {
  flex: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: var(--bg-color-default);
}

.view-home__body .el-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22.5%;
  height: 200px;
  margin-left: 2%;
  margin-bottom: 2%;
  border-radius: var(--bd-radius);
  font-size: 1.5em;
  cursor: pointer;
}
  .configBtn{
    position: fixed;
    right: 100px;
    top: 100px;
    font-size: 1.5em;
    color: #303133;
    cursor: pointer;
  }
  .configBtn i{
    font-size: 1.2em;
    margin-right: 5px;
    vertical-align: middle;
  }
  .configBtn:hover,.configBtn:hover i{
    color: #5cb6ff;
  }

  .row-one{
    margin-top: 8%;
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .row-two{
    display: flex;
    flex-direction: row;
    width: 100%;
  }
</style>
